"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionMW = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const globalVars_1 = require("../../common/globalVars");
const question_1 = require("../../question");
const visitor_1 = require("../../ui/visitor");
function QuestionMW(key, fromAction = false) {
    return async (ctx, next) => {
        const inputs = ctx.arguments[0];
        if (fromAction) {
            inputs.outputEnvVarNames = ctx.arguments[2];
        }
        const node = question_1.questionNodes[key](inputs.platform);
        const askQuestionRes = await (0, visitor_1.traverse)(node, inputs, globalVars_1.TOOLS.ui, globalVars_1.TOOLS.telemetryReporter);
        if (askQuestionRes.isErr()) {
            if (fromAction) {
                ctx.result = {
                    result: (0, teamsfx_api_1.err)(askQuestionRes.error),
                    summaries: [],
                };
            }
            else {
                ctx.result = (0, teamsfx_api_1.err)(askQuestionRes.error);
            }
            return;
        }
        await next();
    };
}
exports.QuestionMW = QuestionMW;
//# sourceMappingURL=questionMW.js.map